import React, { useEffect, useRef, useState, useCallback } from "react";
import { IoMdClose } from "react-icons/io";
import { FaPause, FaPlay, FaStop } from "react-icons/fa";
import { MdDeleteOutline } from "react-icons/md";
import { AudioRecorder, useAudioRecorder } from "react-audio-voice-recorder";
import { FFmpeg } from "@ffmpeg/ffmpeg";
import axiosInstance from "../../Services/axios";
import { toast } from "react-toastify";
import { showToast } from "../toastConfig/ToastConfig";
const InstructionsNoteModal = ({ toggleshowInstruction, onSaveSuccess }) => {
  const [recordedAudio, setRecordedAudio] = useState(null);
  const [pauseicon, setPauseicon] = useState(false);
  const [isPlaying, setIsPlaying] = useState(false);
  const [restartRecord, setRestartRecord] = useState(true);
  const [recordedAudioUrl, setRecordedAudioUrl] = useState(null);
  const [recordingTime, setRecordingTime] = useState(0);
  const [instructionisLoading, setInstructionIsLoading] = useState(false);
  const [consulation, setConsulation] = useState(() => localStorage.getItem("additionalNotes") || "");
  const [updateVoiceNote, setUpdateVoiceNote] = useState(false)
  const [playTime, setPlayTime] = useState(0);
  const [audioDuration, setAudioDuration] = useState(0);


  const audioRef = useRef(null);
  const timerRef = useRef(null);
  const isDeletingRef = useRef(false);

  useEffect(() => {
    if (pauseicon) {
      timerRef.current = setInterval(() => {
        setRecordingTime((prev) => prev + 1);
      }, 1000);
    } else {
      clearInterval(timerRef.current);
      timerRef.current = null;
    }

    return () => clearInterval(timerRef.current);
  }, [pauseicon]);

  useEffect(() => {
    let interval;
    if (isPlaying && audioRef.current) {
      interval = setInterval(() => {
        setPlayTime(audioRef.current.currentTime);
      }, 500);
    } else {
      clearInterval(interval);
    }
    return () => clearInterval(interval);
  }, [isPlaying]);

  useEffect(() => {
    const savedAudio = localStorage.getItem("recordedAudio");
    const storedDuration = localStorage.getItem("audioDuration");

    if (savedAudio) {
      const newAudio = new Audio(savedAudio);
      audioRef.current = newAudio;
      newAudio.onended = () => setIsPlaying(false);
      setRecordingTime(Number(storedDuration));
      setRecordedAudio(savedAudio);
      setRecordedAudioUrl(savedAudio);
      setRestartRecord(false);
      setPauseicon(false);
      setIsPlaying(false);

      // newAudio.onloadedmetadata = () => {
      //   setAudioDuration(Math.floor(newAudio.duration)); // ✅ exact duration
      //   localStorage.setItem("audioDuration", Math.floor(newAudio.duration));
      // };
    }
  }, []);


  const recorderControls = useAudioRecorder(
    {
      noiseSuppression: true,
      echoCancellation: true,
    },
    (err) => console.error(err)
  );

  const addAudioElement = (blob) => {
    if (isDeletingRef.current) return;
    if (!blob) return;

    if (audioRef.current) {
      audioRef.current.pause();
      audioRef.current = null;
    }

    const audioUrl = URL.createObjectURL(blob);
    const audio = new Audio(audioUrl);

    audio.onended = () => setIsPlaying(false);

    audio.onloadedmetadata = () => {
      setAudioDuration(Math.floor(audio.duration)); // ✅ exact duration
      localStorage.setItem("audioDuration", Math.floor(audio.duration));
    };

    audioRef.current = audio;
    setRecordedAudio(blob);
    setRecordedAudioUrl(audioUrl);
    setRestartRecord(false);
    setPauseicon(false);


    const reader = new FileReader();
    reader.onloadend = () => {
      const base64data = reader.result;
      const newAudioUrl = URL.createObjectURL(blob);


      localStorage.setItem("recordedAudio", base64data);
      localStorage.setItem("recordedAudioUrl", newAudioUrl);
      localStorage.setItem("audioDuration", recordingTime);
    };
    reader.readAsDataURL(blob);
    setUpdateVoiceNote(true)
  };

  const togglePlayAudio = () => {
    if (!audioRef.current) return;

    if (isPlaying) {
      audioRef.current.pause();
    } else {
      audioRef.current.play();
    }
    setIsPlaying(!isPlaying);
  };

  const deleteRecordedAudio = useCallback(() => {
    isDeletingRef.current = true;
    if (audioRef.current) {
      audioRef.current.pause();
      audioRef.current = null;
    }

    if (recordedAudioUrl) {
      URL.revokeObjectURL(recordedAudioUrl);
    }

    setRecordedAudio(null);
    setRecordedAudioUrl(null);
    setRestartRecord(true);
    setPauseicon(false);
    setRecordingTime(0);
    setIsPlaying(false);
    setUpdateVoiceNote(false)
    localStorage.removeItem("recordedAudio");
    localStorage.removeItem("audioDuration");
    setTimeout(() => {
      isDeletingRef.current = false;   // reset flag
    }, 300);

  }, [recordedAudioUrl]);

  const ffmpeg = new FFmpeg();

  const convertToMp4 = async (audioBlob) => {
    if (!ffmpeg.loaded) await ffmpeg.load();

    const buffer = await audioBlob.arrayBuffer();
    const uint8Array = new Uint8Array(buffer);

    await ffmpeg.writeFile("input.webm", uint8Array);
    await ffmpeg.exec(["-i", "input.webm", "output.mp4"]);

    const outputData = await ffmpeg.readFile("output.mp4");
    return new Blob([outputData], { type: "video/mp4" });
  };

  const handleSave = async () => {
    if (instructionisLoading) return;
    if (consulation.length > 0 && consulation.trim().length === 0) {
      showToast("Please enter a valid note.");
      return;
    }
    const cleanNote = consulation.trim().replace(/\s+/g, " ");
    setConsulation(cleanNote);
    localStorage.setItem("additionalNotes", cleanNote);
    setInstructionIsLoading(true);

    try {
      if (!updateVoiceNote) {
        toggleshowInstruction()
      } else {
        const mp4Blob = await convertToMp4(recordedAudio);

        const formData = new FormData();
        formData.append("file", mp4Blob, "audio.mp4");

        const response = await axiosInstance.post(
          "/user/products/upload_audio_note",
          formData
        );

        if (response.status == 200) {
          // onSaveSuccess?.(response.data.file_url);
          localStorage.setItem("recoredURL", response.data.file_url);
          toggleshowInstruction()
        }
      }
    } catch (err) {
      console.error("Upload failed", err);
    } finally {
      setInstructionIsLoading(false);

    }


  };

  // const handleSendInstructions = async (type) => {
  //   try {
  //     if (consulation.length > 0 && consulation.trim().length === 0) {
  //       toast.error("Please enter a valid note.");
  //       return;
  //     }

  //     let url = "";

  //     if (type != 1 && recordedAudio) {
  //       setInstructionIsLoading(true)
  //       const mp4Blob = await convertToMp4(recordedAudio);

  //       const formData = new FormData();
  //       formData.append("file", mp4Blob, "audio.mp4");

  //       const uploadRes = await axiosInstance.post(
  //         "/user/products/upload_audio_note",
  //         formData,
  //         { headers: { "Content-Type": "multipart/form-data" } }
  //       );

  //       if (uploadRes.status == 200 && uploadRes.data?.file_url) {
  //         url = uploadRes.data.file_url;
  //         localStorage.setItem("recoredURL", url);
  //       } else {
  //         console.error("Failed to upload audio note");
  //         return;
  //       }
  //     }

  //     const reqData = {
  //       order_id: order_id,
  //       delivery_instructions: instructionsOption,
  //       additional_notes: consulation.trim(),
  //       voice_note: type == 1 ? "" : type == 2 ? oldRecordurl : url,
  //     };

  //     const updateRes = await axiosInstance.post(
  //       "user/products/update_delivery_instructions",
  //       reqData
  //     );

  //     if (updateRes.status == 200) {

  //       // setInstructionIsLoading(false)

  //       if (type != 1) {
  //         setInstructionIsLoading(false); 
  //       } 
  //     } else {
  //       console.error("Failed to update instructions");
  //     }
  //   } catch (error) {
  //     console.error("Error sending instructions:", error);
  //   }
  // };

  const formatTime = (sec = 0) => {
    const total = Math.floor(sec);
    const m = Math.floor(total / 60);
    const s = total % 60;
    return `${m}:${String(s).padStart(2, "0")}`;
  };

  // const formatTime = (seconds) => {
  //   if (!seconds || isNaN(seconds)) return "00:00";
  //   const rounded = Math.floor(seconds);
  //   const m = Math.floor(rounded / 60).toString().padStart(2, "0");
  //   const s = (rounded % 60).toString().padStart(2, "0");
  //   return `${m}:${s}`;
  // };

  console.log("play time:", formatTime(playTime), "/", formatTime(recordingTime));
  return (
    <>
      <div className="modalBackdrop locationListBackdrop"> </div>
      <div className="offcanvas offcanvas-bottom instructionsModel show">
        <div className=" ">
          <div className="d-flex justify-content-between">
            <h5 className="fs-16 ff-poppins-semiBold">Instructions Note</h5>
            {!pauseicon && <IoMdClose onClick={() => toggleshowInstruction()} />}
          </div>

          <div className={`w-100 rounded-2 p-1 secondary-border `} style={{ height: 55 }}>
            {restartRecord ? (
              <div className="d-flex align-items-center justify-content-between p-1">

                <p className={`fs-12 m-0 ff-poppins-medium ${pauseicon ? "text-danger" : ""}`}   >
                  {pauseicon ? `Recording... ${formatTime(recordingTime)}`
                    : "Click to record instructions"}
                </p>
                <div className="d-flex justify-content-center align-items-center" style={{ width: 36, height: 36 }}
                  onClick={() => {
                    if (pauseicon) {
                      recorderControls.stopRecording();
                    }
                    setPauseicon(!pauseicon);
                  }}
                >
                  {!pauseicon ? (
                    <AudioRecorder onRecordingComplete={addAudioElement}
                      recorderControls={recorderControls} showVisualizer={false} />
                  ) : (
                    <FaPause className="fs-18 primary-text" />
                  )}
                </div>
              </div>
              // <div className="d-flex justify-content-between align-items-center">
              //   <p className="fs-12 ms-2">
              //     {pauseicon ? `Recording... ${formatTime(recordingTime)}` : "Click to record instructions"}
              //   </p>

              //   {!pauseicon ? (
              //     <AudioRecorder
              //       recorderControls={recorderControls}
              //       onRecordingComplete={addAudioElement}
              //     />
              //   ) : (
              //     <FaPause onClick={() => recorderControls.stopRecording()} />
              //   )}
              // </div>
            ) : (
              <div className="d-flex align-items-center justify-content-center h-100">
                <div className="d-flex align-items-center justify-content-between gap-5">

                  <div className="d-flex align-items-center  gap-2">
                    <div onClick={togglePlayAudio} className="fs-15 primary-text cursor-pointer"     >
                      {isPlaying ? <FaStop /> : <FaPlay />}
                    </div>

                    <div className="fs-14 primary-text ff-poppins-medium">
                      Instructions Recorded
                    </div>
                  </div>

                  <div className="d-flex align-items-center gap-2">
                    <div className="fs-14 ff-poppins-medium primary-text">
                      {formatTime(playTime)} / {recordingTime == 0 ? "0.00" : formatTime(recordingTime)}
                    </div>

                    <div className=" mb-1 text-danger cursor-pointer"
                      onClick={() => { setRecordedAudioUrl(null); deleteRecordedAudio(); setRestartRecord(true); setPlayTime(0); }}   >
                      <MdDeleteOutline size={20} />
                    </div>
                  </div>
                </div>
              </div>
            )}
          </div>

          <h6 className="mt-3 fs-14 ff-poppins-semiBold">Additional Note</h6>
          <textarea className="textAreaRP text-dark ff-poppins-regular fs-13 mb-1" maxLength={120} value={consulation}
            onChange={(e) => setConsulation(e.target.value)}
            onKeyDown={(e) => {
              if (e.key === "Enter" && !e.shiftKey) {
                e.preventDefault();
                if (!pauseicon) handleSave();
              }
            }} placeholder="Type your instructions here..." />
          <div className="text-end ff-poppins-semiBold fs-12">{consulation.length}/120</div>

          <button disabled={pauseicon} className="InstructionsNoteSaveBtn" onClick={handleSave}   >
            {instructionisLoading ? "Saving..." : "Save"}
          </button>
        </div>
      </div>
    </>
  );
};

export default InstructionsNoteModal;